import { z } from 'zod'

export const OperatorsLicensesParser = z.array(
  z.object({
    operators: z.array(
      z.object({
        id: z.number(),
        name: z.string()
      })
    ),
    property: z.string()
  })
)

export const OperatorParser = z.object({
  createdDate: z.string(),
  email: z.string(),
  id: z.number(),
  name: z.string()
})

export const OperatorRequestResponseParser = z.object({
  data: z.array(OperatorParser)
})

export const OpsConsoleOperatorRequestResponseParser = z.array(OperatorParser)

export const DeleteOperatorResponseParser = z.object({ data: z.string() })

export const OpsConsoleDeleteOperatorResponseParser = z.string()

export type OperatorsLicensesResponse = z.infer<typeof OperatorsLicensesParser>

export type GetOperatorsProps = {
  token: string
  countUsers?: boolean
  operatorUrl?: string
}

export type Operator = z.infer<typeof OperatorParser>

export type OperatorWithUsersCount = Operator & {
  usersCount: number
}

export type OperatorsMap = {
  [id: string]: OperatorWithUsersCount
}

export const CreateOperatorParser = z.object({ email: z.string(), name: z.string() })

export const CreateOperatorResponseParser = z.object({ data: z.object({ message: z.string() }) })

export const OpsConsoleCreateOperatorResponseParser = z.object({ message: z.string() })

export type CreateDDEOperatorData = z.infer<typeof CreateOperatorParser>

export type CreateDDEOperator = {
  token: string
  data: CreateDDEOperatorData
}
